// locale metrics
export const LOCALE_PICKER_COUNT = 'locale-picker-count';
